// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"153":"43dbb47a","557":"7e808447","650":"1fe14ea1","760":"5a9da544"}[chunkId] + ".chunk.css";
};